(function () {
  'use strict';

  if (window.fiAklaInviteUsOverLoaded) return;
  window.fiAklaInviteUsOverLoaded = true;

  var fiAklaApntlySkin = "@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Montserrat:wght@400;500;600;700&display=swap');\n\n* {\n  --primary: #940002 !important;\n  --secondary: #fd5c02 !important;\n  --grey: #f1eadb !important;\n  --text-black: #111111 !important;\n  --text-light-black: #5a4b45 !important;\n  box-sizing: border-box;\n}\n\nbody.is-embed-true,\n.is-embed-true.fade-in {\n  margin: 0 !important;\n  color: #111111 !important;\n  background: transparent !important;\n}\n\n.is-embed-true .modal {\n  height: auto !important;\n  min-height: 0 !important;\n  align-items: flex-start !important;\n}\n\n.is-embed-true .modal-container {\n  width: 100% !important;\n  max-width: none !important;\n  margin: 0 !important;\n  padding: 24px !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  color: #111111 !important;\n  background: #f1eadb !important;\n  box-shadow: none !important;\n  font-family: 'Montserrat', sans-serif !important;\n}\n\n.is-embed-true .close-icon {\n  display: none !important;\n}\n\n.is-embed-true .main-heading {\n  margin: 0 0 20px !important;\n  color: #940002 !important;\n  font-family: 'Bebas Neue', sans-serif !important;\n  font-size: 34px !important;\n  font-weight: 400 !important;\n  letter-spacing: 0.02em !important;\n  line-height: 1 !important;\n  text-transform: uppercase !important;\n}\n\n.is-embed-true .container {\n  gap: 20px !important;\n  justify-content: flex-start !important;\n}\n\n.is-embed-true .date-time-picker {\n  width: 100% !important;\n  max-width: none !important;\n}\n\n.is-embed-true .mobile-calendar-selector {\n  margin: 0 0 4px !important;\n}\n\n.is-embed-true label {\n  color: #940002 !important;\n  font-weight: 700 !important;\n}\n\n.is-embed-true .vs__dropdown-toggle {\n  min-height: 48px !important;\n  border: 2px solid #940002 !important;\n  border-radius: 0 !important;\n  background: #fffdf7 !important;\n}\n\n.is-embed-true .vs__selected {\n  color: #111111 !important;\n  background: transparent !important;\n}\n\n.is-embed-true .vs__open-indicator,\n.is-embed-true .vs__clear {\n  fill: #940002 !important;\n}\n\n.is-embed-true .vs__dropdown-menu {\n  border: 2px solid #940002 !important;\n  border-radius: 0 !important;\n  background: #fffdf7 !important;\n}\n\n.is-embed-true .vs__dropdown-option--highlight {\n  color: #f1eadb !important;\n  background: #940002 !important;\n}\n\n.is-embed-true .vc-container {\n  width: 100% !important;\n  border: 2px solid #940002 !important;\n  border-radius: 0 !important;\n  color: #111111 !important;\n  background: #fffdf7 !important;\n}\n\n.is-embed-true .vc-title {\n  color: #940002 !important;\n  font-family: 'Bebas Neue', sans-serif !important;\n  font-size: 25px !important;\n  font-weight: 400 !important;\n  letter-spacing: 0.02em !important;\n  text-transform: uppercase !important;\n}\n\n.is-embed-true .vc-highlight {\n  background: #fd5c02 !important;\n}\n\n.is-embed-true .vc-day-content:hover {\n  color: #f1eadb !important;\n  background: #940002 !important;\n}\n\n.is-embed-true .timezone-container {\n  margin: 14px 0 18px !important;\n  color: #5a4b45 !important;\n}\n\n.is-embed-true .side-menu {\n  width: 100% !important;\n  margin: 0 !important;\n}\n\n.is-embed-true .select-time-slot {\n  margin: 0 0 10px !important;\n  color: #940002 !important;\n  font-family: 'Bebas Neue', sans-serif !important;\n  font-size: 23px !important;\n  letter-spacing: 0.02em !important;\n  line-height: 1 !important;\n  text-transform: uppercase !important;\n}\n\n.is-embed-true .time-slots-container {\n  max-height: none !important;\n  gap: 8px !important;\n  overflow: visible !important;\n}\n\n.is-embed-true .time-slot-container {\n  width: 100% !important;\n}\n\n.is-embed-true .time-slot {\n  margin: 0 !important;\n  padding: 11px 14px !important;\n  border: 2px solid #940002 !important;\n  border-radius: 0 !important;\n  color: #940002 !important;\n  background: #fffdf7 !important;\n  font-size: 14px !important;\n  font-weight: 700 !important;\n}\n\n.is-embed-true .time-slot.selected,\n.is-embed-true .time-slot:hover {\n  color: #f1eadb !important;\n  background: #940002 !important;\n}\n\n.is-embed-true .time-slot.disabled,\n.is-embed-true .time-slot.disabled:hover {\n  color: #5a4b45 !important;\n  background: #f1eadb !important;\n  opacity: 0.38 !important;\n}\n\n.is-embed-true .btn-book-margin {\n  margin-top: 18px !important;\n}\n\n.is-embed-true .book-button-container .btn-book,\n.is-embed-true .btn-book-questions,\n.is-embed-true .btn-book-customer-details-questions {\n  width: 100% !important;\n  max-width: none !important;\n  min-height: 50px !important;\n  border: 2px solid #940002 !important;\n  border-radius: 0 !important;\n  color: #f1eadb !important;\n  background: #fd5c02 !important;\n  box-shadow: 4px 4px 0 #940002 !important;\n  font-family: 'Bebas Neue', sans-serif !important;\n  font-size: 24px !important;\n  font-weight: 400 !important;\n  letter-spacing: 0.04em !important;\n  text-transform: uppercase !important;\n}\n\n.is-embed-true .book-button-container .btn-book[disabled],\n.is-embed-true .btn-book-questions[disabled],\n.is-embed-true .btn-book-customer-details-questions[disabled] {\n  color: #f1eadb !important;\n  background: #fd5c02 !important;\n  opacity: 0.38 !important;\n}\n\n.is-embed-true .time-slot-not-selected-text {\n  margin: 12px 0 0 !important;\n  color: #5a4b45 !important;\n  font-size: 12px !important;\n}\n\n.is-embed-true .answer-text,\n.is-embed-true .vue-tel-input.answer-text {\n  min-height: 46px !important;\n  border: 2px solid #940002 !important;\n  border-radius: 0 !important;\n  color: #111111 !important;\n  background: #fffdf7 !important;\n}\n\n.is-embed-true .free-booking-success-message-container {\n  border: 2px solid #940002 !important;\n  color: #940002 !important;\n  background: #fffdf7 !important;\n}\n\n@media only screen and (max-width: 480px) {\n  .is-embed-true .modal-container {\n    width: 100% !important;\n    padding: 16px !important;\n  }\n\n  .is-embed-true .main-heading {\n    font-size: 30px !important;\n  }\n\n  .is-embed-true .container {\n    gap: 16px !important;\n  }\n}";

  function applyFiAklaApntlySkin() {
    var config = window.appointlyConfig;
    var booking = config && config.booking;
    if (!booking || typeof booking.bookingHtml !== 'string') return false;
    if (booking.bookingHtml.indexOf('data-fi-akla-apntly-skin') !== -1) return true;

    booking.bookingHtml = booking.bookingHtml.replace(
      '</head>',
      '<style data-fi-akla-apntly-skin>' + fiAklaApntlySkin + '</style></head>'
    );
    return true;
  }

  if (!applyFiAklaApntlySkin()) {
    var fiAklaSkinAttempts = 0;
    var fiAklaSkinTimer = window.setInterval(function () {
      fiAklaSkinAttempts += 1;
      if (applyFiAklaApntlySkin() || fiAklaSkinAttempts >= 240) {
        window.clearInterval(fiAklaSkinTimer);
      }
    }, 25);
  }

  function formatEgp(cents) {
    return 'EGP ' + new Intl.NumberFormat('en-EG', {
      maximumFractionDigits: 0
    }).format(Number(cents || 0) / 100);
  }

  function init(root) {
    if (!root || root.dataset.iouReady === 'true') return;
    root.dataset.iouReady = 'true';

    var form = root.querySelector('form');
    var variantData = root.querySelector('[data-iou-variants]');
    if (!form || !variantData) return;

    var variants = [];
    try {
      variants = JSON.parse(variantData.textContent || '[]');
    } catch (error) {
      console.error('[Fi Akla] Could not read Invite Us Over variants.', error);
      return;
    }

    var optionSelects = Array.prototype.slice.call(root.querySelectorAll('[data-iou-option]'));
    var variantId = root.querySelector('[data-iou-variant-id]');
    var price = root.querySelector('[data-iou-price]');
    var packageProperty = root.querySelector('[data-iou-package-property]');
    var shoppingProperty = root.querySelector('[data-iou-shopping-property]');
    var extraMains = root.querySelector('[data-iou-extra-mains]');
    var extraSides = root.querySelector('[data-iou-extra-sides]');
    var coversOutput = root.querySelector('[data-iou-covers]');
    var addonTotalOutput = root.querySelector('[data-iou-addon-total]');
    var addonProperty = root.querySelector('[data-iou-addon-property]');
    var submit = root.querySelector('[data-iou-submit]');
    var formError = root.querySelector('[data-iou-form-error]');
    var chef = root.querySelector('[data-iou-chef]');
    var previousChefWrap = root.querySelector('[data-iou-previous-chef]');
    var previousChef = previousChefWrap && previousChefWrap.querySelector('input');
    var allergyInputs = Array.prototype.slice.call(root.querySelectorAll('[data-iou-allergy]'));
    var allergyWrap = root.querySelector('[data-iou-allergy-details]');
    var allergyDetails = allergyWrap && allergyWrap.querySelector('textarea');
    var applianceInputs = Array.prototype.slice.call(root.querySelectorAll('[data-iou-appliance]'));
    var applianceOther = root.querySelector('[data-iou-appliance-other]');
    var applianceDetailsWrap = root.querySelector('[data-iou-appliance-details]');
    var applianceDetails = applianceDetailsWrap && applianceDetailsWrap.querySelector('textarea');
    var applianceValue = root.querySelector('[data-iou-appliances-value]');
    var applianceError = root.querySelector('[data-iou-appliances-error]');
    var appointmentDate = root.querySelector('[data-iou-appointment-date]');
    var arrivalTime = root.querySelector('[data-iou-arrival-time]');
    var calendarSummary = root.querySelector('[data-iou-calendar-summary]');
    var calendarEmbed = root.querySelector('[data-iou-apntly-embed]');
    var calendarLoading = root.querySelector('[data-iou-calendar-loading]');
    var lastConfirmedBookingKey = '';
    var isSubmitting = false;

    function selectedVariant() {
      var selected = optionSelects.map(function (select) { return select.value; });
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return value === selected[index];
        });
      });
    }

    function selectedCovers() {
      if (root.dataset.iouServiceHandle === 'invite-us-over-fridge-fill') return 4;

      var guestSelect = optionSelects.find(function (select) {
        return /guest|people/i.test(select.dataset.optionName || '');
      }) || optionSelects.find(function (select) {
        return (select.dataset.optionName || '').toLowerCase() !== 'shopping method';
      });
      var match = guestSelect && String(guestSelect.value || '').match(/\d+/);
      return match ? Number(match[0]) : 0;
    }

    function selectedAddonCounts() {
      return {
        mains: Number(extraMains && extraMains.value || 0),
        sides: Number(extraSides && extraSides.value || 0)
      };
    }

    function addonTotalCents() {
      var covers = selectedCovers();
      var counts = selectedAddonCounts();
      return covers * ((counts.mains * 25000) + (counts.sides * 12000));
    }

    function syncAddonSummary() {
      var covers = selectedCovers();
      var total = formatEgp(addonTotalCents());
      if (coversOutput) coversOutput.textContent = String(covers);
      if (addonTotalOutput) addonTotalOutput.textContent = total;
      if (addonProperty) addonProperty.value = total;
    }

    function syncVariant() {
      var variant = selectedVariant();
      optionSelects.forEach(function (select) {
        var optionName = (select.dataset.optionName || '').toLowerCase();
        if (optionName === 'shopping method' && shoppingProperty) shoppingProperty.value = select.value;
        if (optionName !== 'shopping method' && packageProperty) packageProperty.value = select.value;
      });
      if (!variant) {
        variantId.value = '';
        price.textContent = 'UNAVAILABLE';
        syncReadyState();
        return;
      }

      variantId.value = variant.id;
      syncAddonSummary();
      price.textContent = formatEgp(Number(variant.price || 0) + addonTotalCents());
      syncReadyState();
    }

    function syncChef() {
      var needsName = chef && chef.value === 'A chef I have booked before';
      if (previousChefWrap) previousChefWrap.toggleAttribute('data-iou-hidden', !needsName);
      if (previousChef) {
        previousChef.disabled = !needsName;
        previousChef.required = needsName;
        if (!needsName) previousChef.value = '';
      }
      syncReadyState();
    }

    function syncAllergy() {
      var selected = allergyInputs.find(function (input) { return input.checked; });
      var needsDetails = selected && selected.value === 'Allergies or dietary requirements to declare';
      if (allergyWrap) allergyWrap.toggleAttribute('data-iou-hidden', !needsDetails);
      if (allergyDetails) {
        allergyDetails.disabled = !needsDetails;
        allergyDetails.required = !!needsDetails;
        if (!needsDetails) allergyDetails.value = '';
      }
      syncReadyState();
    }

    function syncAppliances(showError) {
      var selected = applianceInputs.filter(function (input) { return input.checked; });
      var needsDetails = !!(applianceOther && applianceOther.checked);
      applianceValue.value = selected.map(function (input) { return input.value; }).join(', ');
      if (applianceDetailsWrap) applianceDetailsWrap.toggleAttribute('data-iou-hidden', !needsDetails);
      if (applianceDetails) {
        applianceDetails.disabled = !needsDetails;
        applianceDetails.required = needsDetails;
        if (!needsDetails) applianceDetails.value = '';
      }
      if (applianceError) {
        applianceError.toggleAttribute('data-iou-hidden', !(showError && selected.length === 0));
      }
      syncReadyState();
      return selected.length > 0;
    }

    function calendarReady() {
      return !!(appointmentDate && appointmentDate.value && arrivalTime && arrivalTime.value);
    }

    function syncReadyState() {
      var hasVariant = !!(variantId && variantId.value);
      var hasAppliance = applianceInputs.some(function (input) { return input.checked; });
      var allergySelected = allergyInputs.some(function (input) { return input.checked; });
      var allergyComplete = !allergyDetails || allergyDetails.disabled || !!allergyDetails.value.trim();
      var chefComplete = !previousChef || previousChef.disabled || !!previousChef.value.trim();
      var applianceDetailsComplete = !applianceDetails || applianceDetails.disabled || !!applianceDetails.value.trim();
      var ready = hasVariant && calendarReady() && hasAppliance && allergySelected && allergyComplete && chefComplete && applianceDetailsComplete;
      if (submit) submit.disabled = !ready || isSubmitting;
      if (formError && ready) formError.setAttribute('data-iou-hidden', '');
    }

    optionSelects.forEach(function (select) {
      select.addEventListener('change', syncVariant);
    });
    if (extraMains) extraMains.addEventListener('change', syncVariant);
    if (extraSides) extraSides.addEventListener('change', syncVariant);
    if (chef) chef.addEventListener('change', syncChef);
    if (previousChef) previousChef.addEventListener('input', syncReadyState);
    allergyInputs.forEach(function (input) { input.addEventListener('change', syncAllergy); });
    if (allergyDetails) allergyDetails.addEventListener('input', syncReadyState);
    applianceInputs.forEach(function (input) {
      input.addEventListener('change', function () { syncAppliances(false); });
    });
    if (applianceDetails) applianceDetails.addEventListener('input', syncReadyState);

    function syncApntlyCalendar() {
      var iframe = document.getElementById('apntly-booking-iframe');
      if (iframe && calendarEmbed && calendarEmbed.contains(iframe) && calendarLoading) {
        calendarLoading.setAttribute('data-iou-hidden', '');
      }

      var client = window.appointlyClient;
      var bookingData = client && client.apntlyBookingModalData;
      if (!client || !bookingData || Number(bookingData.screen) !== 4) return;

      var slot = null;
      try {
        slot = client.getSelectedSlot();
      } catch (error) {
        slot = null;
      }
      if (!slot) return;

      var date = '';
      try {
        date = client.getDateFromTimestampStartBrowserFormatted(slot);
      } catch (error) {
        date = '';
      }
      if (!date && slot.bookingTimestamp) {
        try {
          date = new Intl.DateTimeFormat('en-EG', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
          }).format(new Date(Number(slot.bookingTimestamp)));
        } catch (error) {
          date = '';
        }
      }

      var time = [slot.start, slot.end].filter(Boolean).join(' - ');
      var bookingKey = [
        slot.bookingTimestamp,
        slot.start,
        slot.end,
        slot.serviceVariant && slot.serviceVariant.uniqueId
      ].join('|');

      if (!date || !time || bookingKey === lastConfirmedBookingKey) return;
      lastConfirmedBookingKey = bookingKey;
      root.dispatchEvent(new CustomEvent('iou:calendar-selected', {
        detail: { date: date, time: time }
      }));
    }

    root.addEventListener('iou:calendar-selected', function (event) {
      var detail = event.detail || {};
      appointmentDate.value = detail.date || '';
      arrivalTime.value = detail.time || '';
      if (calendarSummary) {
        calendarSummary.textContent = calendarReady()
          ? 'Chef time reserved: ' + appointmentDate.value + ' · ' + arrivalTime.value
          : 'No appointment reserved yet.';
      }
      syncReadyState();
    });

    if (calendarEmbed) {
      syncApntlyCalendar();
      window.setInterval(syncApntlyCalendar, 500);
    }

    function bookingProperties() {
      var properties = {};
      new FormData(form).forEach(function (value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (match && String(value).trim()) properties[match[1]] = String(value).trim();
      });
      return properties;
    }

    function addonProperties(group, label) {
      return {
        '_Booking type': 'Invite Us Over add-on',
        '_Booking group': group,
        '_Service': root.dataset.iouServiceTitle || '',
        'Add-on': label,
        'Appointment date': appointmentDate.value,
        'Arrival time': arrivalTime.value
      };
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      var appliancesComplete = syncAppliances(true);
      if (!calendarReady() || !appliancesComplete || !form.checkValidity()) {
        if (formError) formError.removeAttribute('data-iou-hidden');
        form.reportValidity();
        return;
      }

      var counts = selectedAddonCounts();
      var covers = selectedCovers();
      var mainAddonId = Number(root.dataset.iouExtraMainVariant || 0);
      var sideAddonId = Number(root.dataset.iouExtraSideVariant || 0);
      if ((counts.mains || counts.sides) && (!covers || (counts.mains && !mainAddonId) || (counts.sides && !sideAddonId))) {
        if (formError) {
          formError.textContent = 'The add-on price could not be configured. Please refresh and try again.';
          formError.removeAttribute('data-iou-hidden');
        }
        return;
      }

      var bookingGroup = 'iou-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
      var properties = bookingProperties();
      properties['_Booking group'] = bookingGroup;
      var items = [{
        id: Number(variantId.value),
        quantity: 1,
        properties: properties
      }];
      if (counts.mains) {
        items.push({
          id: mainAddonId,
          quantity: covers * counts.mains,
          properties: addonProperties(bookingGroup, 'Extra main · EGP 250 per person')
        });
      }
      if (counts.sides) {
        items.push({
          id: sideAddonId,
          quantity: covers * counts.sides,
          properties: addonProperties(bookingGroup, 'Extra side · EGP 120 per person')
        });
      }

      isSubmitting = true;
      if (submit) {
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        submit.textContent = 'ADDING…';
      }
      if (formError) formError.setAttribute('data-iou-hidden', '');

      var shopRoot = window.Shopify && Shopify.routes && Shopify.routes.root || '/';
      try {
        var response = await fetch(shopRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        var result = await response.json().catch(function () { return {}; });
        if (!response.ok) throw new Error(result.description || result.message || 'Could not add this booking.');
        window.location.assign(shopRoot + 'cart');
      } catch (error) {
        isSubmitting = false;
        if (submit) {
          submit.removeAttribute('aria-busy');
          submit.textContent = 'ADD TO BOOKING';
        }
        syncReadyState();
        if (formError) {
          formError.textContent = error.message || 'Could not add this booking. Please try again.';
          formError.removeAttribute('data-iou-hidden');
        }
      }
    });

    syncVariant();
    syncChef();
    syncAllergy();
    syncAppliances(false);
  }

  function initAll() {
    document.querySelectorAll('[data-iou-product]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector && event.target.querySelector('[data-iou-product]');
    if (root) init(root);
  });
})();
